import { createSlice } from '@reduxjs/toolkit';
import { statusTypes } from '@/constants/types';
import fetchBreadcrumb from '../thunk/breadcrumb-thunk';

const breadcrumbSlice = createSlice({
  name: 'breadcrumb',
  initialState: {
    items: [],
    total: 0,
    isLoading: false,
    error: null,
    fetchStatus: statusTypes.idle,
  },
  reducers: {
    resetBreadcrumb: (state) => {
      state.items = [];
      state.total = 0;
      state.isLoading = false;
      state.error = null;
      state.fetchStatus = statusTypes.idle;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBreadcrumb.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.items = [];
        state.fetchStatus = statusTypes.loading;
      })
      .addCase(fetchBreadcrumb.fulfilled, (state, action) => {
        state.items = action.payload;
        state.total = action.payload.length;
        state.isLoading = false;
        state.fetchStatus = statusTypes.succeeded;
      })
      .addCase(fetchBreadcrumb.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        state.fetchStatus = statusTypes.failed;
      });
  },
});

export const { resetBreadcrumb } = breadcrumbSlice.actions;

export default breadcrumbSlice.reducer;
